import { render } from "./PageNewsLayout.vue?vue&type=template&id=408cda06&scoped=true"
const script = {}

import "./PageNewsLayout.vue?vue&type=style&index=0&id=408cda06&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408cda06"]])

export default __exports__